import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  container: {
    display: 'flex',
  },
  wrapper: {
    flexShrink: { sm: 0 },
  },
  menuIconButton: {
    display: { sm: 'none' },
    position: 'fixed',
    left: 4,
    top: 20,
    zIndex: 1200,
    color: 'var(--text-primary)',
    bgcolor: 'var(--surface-base)',
    border: 'var(--elevation-1)',
    padding: '4px',
    minWidth: 'unset',
    '&:hover': {
      bgcolor: 'var(--surface-raised)',
      borderColor: 'var(--border-default)',
    },
  },
  menuIconCloseButton: {
    position: 'absolute',
    right: 16,
    top: 16,
    color: 'var(--text-secondary)',
    '&:hover': {
      bgcolor: 'var(--surface-raised)',
    },
  },
  mainContentWrapper: {
    flexGrow: 1,
    p: 0,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    bgcolor: 'var(--surface-base)', // Clinical white
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100vw',
    overflow: 'hidden',
  },
  desktopDrawer: {
    display: { xs: 'none', sm: 'block' },
    '& .MuiDrawer-paper': {
      bgcolor: 'var(--surface-raised)',
      borderRight: '1px solid var(--border-subtle)',
      boxShadow: 'none',
    },
  },
  mobileDrawer: {
    display: { xs: 'block', sm: 'none' },
    '& .MuiDrawer-paper': {
      bgcolor: 'var(--surface-raised)',
      borderRight: '1px solid var(--border-subtle)',
      boxShadow: 'none',
    },
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    height: 64,
    pr: 2,
    pl: 2,
    borderBottom: '1px solid var(--border-subtle)',
    mb: 0,
  },
  drawerLogoWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
  },
  drawerListItemButton: {
    pl: 5,
    py: 0.75,
    mx: 0,
    my: 0,
    borderRadius: 0,
    borderLeft: '2px solid transparent',
    color: 'var(--text-secondary)',
    fontSize: '0.8rem',
    fontFamily: 'var(--font-data)',
    fontWeight: 400,
    transition: 'all 0.15s var(--easing)',
    '&:hover': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--border-default)',
    },
    '&.Mui-disabled': {
      color: 'var(--text-placeholder)',
      opacity: 0.5,
    },
  },
  drawerIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '12px',
    minWidth: '20px',
    justifyContent: 'center',
  },
  drawerIcon: {
    fontSize: 8,
    color: 'rgba(255, 255, 255, 0.5)',
  },
  listItemButton: {
    py: 1.25,
    px: 2,
    mx: 0,
    my: 0,
    borderRadius: 0,
    borderLeft: '3px solid transparent',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    fontFamily: 'var(--font-data)',
    fontSize: '0.875rem',
    letterSpacing: '0.01em',
    transition: 'all 0.15s var(--easing)',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&:hover': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
    },
    '&.active': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
      '&:hover': {
        bgcolor: 'var(--surface-raised)',
        color: 'var(--text-primary)',
      },
    },
  },
  listItemButtonCollapsed: {
    py: 1.25,
    px: 0,
    mx: 0,
    my: 0,
    borderRadius: 0,
    borderLeft: '3px solid transparent',
    color: 'var(--text-secondary)',
    fontWeight: 500,
    transition: 'all 0.15s var(--easing)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
    },
    '&.active': {
      bgcolor: 'var(--surface-overlay)',
      color: 'var(--text-primary)',
      borderLeftColor: 'var(--brand-coral)',
      '&:hover': {
        bgcolor: 'var(--surface-raised)',
        color: 'var(--text-primary)',
      },
    },
  },
  navbarIcon: {
    fontSize: 18,
    marginRight: '12px',
    color: 'inherit',
    opacity: 0.9,
  },
  navbarIconCollapsed: {
    fontSize: 18,
    marginRight: 0,
    color: 'inherit',
    opacity: 0.9,
  },
  notAuthenticatedWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh',
    bgcolor: 'var(--surface-base)',
  },
  logoutButton: {
    mx: 1.5,
    mb: 2,
    mt: 'auto',
    bgcolor: 'var(--brand-coral)',
    color: '#FFFFFF',
    fontWeight: 500,
    borderRadius: 'var(--radius-sm)',
    textTransform: 'none',
    py: 1,
    '&:hover': {
      bgcolor: 'var(--brand-coral-hover)',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(255, 86, 80, 0.3)',
    },
    transition: 'all var(--duration-base) var(--easing)',
  },
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  navigationList: {
    flex: 1,
    pt: 0,
  },
};

export default styles;
